interface ModalCloseButtonProps {
  ariaLabel: string;
  disabled?: boolean;
  onClick: () => void;
}

export default function ModalCloseButton({
  ariaLabel,
  disabled = false,
  onClick,
}: ModalCloseButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className="ml-auto flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <i className="ri-close-line text-base leading-none" aria-hidden="true"></i>
    </button>
  );
}
